module.exports = __webpack_public_path__ + "img/e_3_4_g.09a53a5b.png";